import './register.scss';
import { useAuthRegister } from './hooks/useAuthRegister';
import { RegisterIntro } from './components/RegisterIntro';
import { RegisterForm } from './components/RegisterForm';
import NetworkingVideo from '../../assets/Networking.mp4';

const Register = () => {
  const { 
    inputs, err, isRegistering, handleChange, handleCheckEmail, handleRegister 
  } = useAuthRegister();

  return (
    <div className='register'>
      <video autoPlay loop muted playsInline className="video-background">
        <source src={NetworkingVideo} type="video/mp4" />
      </video>
      
      <div className="video-overlay"></div>

      <div className="card">
        <RegisterIntro />
        
        <RegisterForm 
          inputs={inputs}
          err={err}
          isRegistering={isRegistering}
          handleChange={handleChange}
          handleCheckEmail={handleCheckEmail}
          handleRegister={handleRegister}
        />
      </div>
    </div>
  );
};

export default Register;